var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel"},[_c('div',{staticStyle:{"flex":"0 0 auto","font-size":"1.8rem","align-self":"left"}},[_vm._v(_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value)+" "+_vm._s(_vm.unit))])])
}
var staticRenderFns = []

export { render, staticRenderFns }